module.exports = __webpack_public_path__ + "fi-blue-swan-352786fe13958ca81e5183aab060318f.png";


//////////////////
// WEBPACK FOOTER
// ./Resources/public/static-src/images/product-labels/fi-blue-swan.png
// module id = 82
// module chunks = 0